export async function preloadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = url
    img.onload = () => {
      resolve(url)
    }
    img.onerror = reject
  })
}
